import UserButton from './UserButton.gql';

export default UserButton;
